window.addEventListener('scroll', Nbs.Xlr8PageTemplate.Header.hideAllHeaderMenus, false);
window.addEventListener('resize', Nbs.Xlr8PageTemplate.Header.hideAllHeaderMenus, false);
window.addEventListener('click', Nbs.Xlr8PageTemplate.Header.closeSubMenu, false);

window.addEventListener('resize', Nbs.Xlr8PageTemplate.Menu.setMenuHeight, false);

window.addEventListener('click', Nbs.Xlr8PageTemplate.Menu.MenuDom.closeMobileMenuFromBodyClick, false);

window.addEventListener('resize', Nbs.Xlr8PageTemplate.Flyout.setFlyoutHeight, false);
window.addEventListener('scroll', Nbs.Xlr8PageTemplate.Header.setHeaderSize,false)

Nbs.Xlr8PageTemplate.Utilities.initSvgContainer();
